<template>
    <div class="qrCoder">
    </div>
</template>

<script>
    import QRCode from '../../lib/qrcode';

    export default {
        name: 'QRCode',
        props: {
            propContent: {
                required: true,
                type: String,
                default: ''
            },
            size:{
                required: false,
                type: Number,
                default: 0
            }
        },
        data(){
            return {
                qrcode: null,
                qrcodeIMG:''
            }
        },
        mounted() {
          var CorrectLevelCode = 'L'
          let size = this.size?this.size: this.$el.parentNode.offsetWidth
          // console.log('qrcode size is '+size)
          this.qrcode = new QRCode(this.$el, {text:this.propContent,width:size,height:size}, CorrectLevelCode);
          this.$nextTick(()=>{
            let imgEl = this.$el.querySelector('img')
            let isImgHidden = imgEl.style.display === 'none'
            // 如果二维码图片没有展示，则手动生成图片的地址
            if(isImgHidden) {
              imgEl.style.display = 'block'
              imgEl.setAttribute('src', this.qrcode._oDrawing._elCanvas.toDataURL())
              this.qrcode._oDrawing._elCanvas.style.display = "none"
            }
            imgEl.addEventListener('load', () => {
              this.$emit('qrCodeLoad')
            })
          })
        },
        watch: {
            'propContent': function() {
                new QRCode(this.$el, this.propContent);
            },
            qrcodeIMG(val){
                console.log(val)
                console.log('qrcodeIMG')
                if (val) {
                    this.$emit('setCodeImg',val)
                }
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/common/qrCodeMaker.vue